// eslint-disable-next-line no-use-before-define
import React from 'react'
import ReelVideo from './ReelVideo'
import * as s from './Wild.module.scss'
import {
  centerImageCollection,
  leftImageCollection,
  rightImageCollection,
} from './WildImageCollections'

const Wild = ({
  wildImg = "",
  title,
  titleCaption,
  subTitle,
  subTitleTag,
  posts,
  videos
}) => {
  const imageGroups = [
    [posts?.[0], posts?.[1], posts?.[2]],
    [posts?.[3], posts?.[4], posts?.[5]],
    [posts?.[6], posts?.[7], posts?.[8]],
  ]

  return (
    posts &&
    posts.length !== 0 && (
      <section
        className={[s.root, !wildImg ? s.noWildImg : ""].join(" ")}
        style={{
          background: `${
            wildImg ? `url(${wildImg})` : ''
          } center top / 90% no-repeat rgb(255, 255, 255)`,
        }}
      >
        <div className={s.container}>
          <div className={s.titleCaption}>
            {titleCaption}
          </div>
          <h3 className={s.title}>
            {title}
          </h3>
          <div className={s.subTitle}>
            {subTitle + ' ' + subTitleTag}
          </div>
          <div
            className={s.mainWrapper}
          >
            {videos?.[0] ? (
              <ReelVideo
                src={`${videos[0]?.file?.url}`}
                title={videos[0]?.title}
                wrapperClassName={s.videoWrapper0}
                videoClassName={s.video}
              />
            ) : (
              leftImageCollection(imageGroups.shift())
            )}
            {centerImageCollection(imageGroups.shift())}
            {videos?.[1] ? (
              <ReelVideo
                src={`${videos[1]?.file?.url}`}
                title={videos[1]?.title}
                wrapperClassName={s.videoWrapper1}
                videoClassName={s.video}
              />
            ) : (
              rightImageCollection(imageGroups.shift())
            )}
          </div>
        </div>
      </section>
    )
  )
}
export default Wild
